/**
 * This is shared component for tracking browsing history in the reader (touch and web)
 */
export default class ReaderBrowsingHistoryComponent {
  constructor(router, appState) {
    this._router = router;
    this._appState = appState;
    this._publicationChanged = false;
    this._appState.on("appState:publicationChanged", () => {
      this._publicationChanged = true;
    });
  }

  trackHistory() {
    this._router.listen(this._doNavigation.bind(this));
    this._appState.on("appState:currentpagechanged", () => {
      if (!this._appState.articleLightBoxDisplayed) {
        //set this change in contentidchanged, otherwise 2 location pushes for new alb slide (if slide to next  page)
        this._router.page = this._appState.currentPage + 1;
      }
    });
    this._appState.on("appState:contentIdChanged", () => {
      this._router.updateLocation(
        this._appState.contentPackageId,
        this._appState._publicationId,
        this._appState.currentPage + 1,
        0,
        this._appState.contentid,
        true
      );
    });
  }

  getPageFromHistory() {
    let page = this._router.page;
    if (typeof page === "undefined") {
      page = 0;
    } else if (page > 0) {
      page--;
    }
    return page;
  }

  getContentIdFromHistory() {
    return this._router._contentid;
  }

  ////////////

  /**
   * When hash navigation changes go to the right page
   */
  _doNavigation() {
    const number = this.getPageFromHistory();
    const content = this._router.contentid;
    if (number !== this._appState.currentPage) {
      this._appState
        .changeCurrentPage(number, this._publicationChanged, false)
        .then(() => {
          if (content !== this._appState.contentid) {
            this._appState.contentid = content;
          }
        })
        .catch(() => {
          //TODO: paywall
        });
      this._publicationChanged = false;
    } else if (content !== this._appState.contentid) {
      this._appState.contentid = content;
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/readerBrowsingHistoryComponent.js